module.exports = __webpack_public_path__ + "static/media/1POLICY3.357cbb0c.jpg";